import { useEffect, useState } from 'react';
import { ScrollListener } from '@openclassrooms/ui-web/scroll';
import { useMediaQuery } from '@mui/material';

export const hasReachedEndOfPage = () =>
  document.body.scrollHeight - document.documentElement.scrollTop <= window.innerHeight;

const hasReachedTopOfPage = () => document.documentElement.scrollTop === 0;

export const ANIMATION_DURATION = 500;

export interface UseScrollAnimationArgs {
  toggleVisibilityCallback: (shouldTrigger: boolean) => void;
  hideAtTopOfPage?: boolean;
  showAtEndOfPage?: boolean;
  initialOffset?: string;
}

const useScrollAnimation = ({
  toggleVisibilityCallback,
  hideAtTopOfPage = false,
  showAtEndOfPage = false,
  initialOffset = '0px',
}: UseScrollAnimationArgs) => {
  const [offset, setOffset] = useState(initialOffset);
  const isReducedMotionEnabled = useMediaQuery('(prefers-reduced-motion: reduce)');

  useEffect(() => {
    if (isReducedMotionEnabled) {
      return;
    }
    const scrollListener = new ScrollListener();

    scrollListener.onScrollUp(() => {
      toggleVisibilityCallback(hideAtTopOfPage ? !hasReachedTopOfPage() : true);
    });
    scrollListener.onScrollDown(() => {
      toggleVisibilityCallback(showAtEndOfPage ? hasReachedEndOfPage() : false);
    });

    // eslint-disable-next-line consistent-return
    return () => {
      scrollListener.destroy();
    };
  }, [hideAtTopOfPage, showAtEndOfPage, toggleVisibilityCallback, isReducedMotionEnabled]);

  return [offset, setOffset] as const;
};

export default useScrollAnimation;
